var exports = {
  "qf": "x31de4314--c11f5f--placeholder",
  "TO": "x31de4314--c11f5f--placeholder-active",
  "pB": "x31de4314--c11f5f--label-wrapper",
  "Pf": "x31de4314--c11f5f--label",
  "U9": "x31de4314--c11f5f--count",
  "UE": "x31de4314--c11f5f--arrow",
};

module.exports = exports;
